// @ts-ignore
import useApi from "./ServiceClient.tsx";
import { config } from "./config";

export const useInvitationManagement = () => {
  const { GET, POST, DELETE, dynamicRequest } = useApi(); // Use API methods inside a React hook

  const getInvitations = (email) => {
    const response = GET(
      `${config?.intivation_management?.END_POINTS?.INVITE}/${email}`
    );
    return response;
  };

  const sendInvitation = (data) => {
    const response = POST(
      config?.intivation_management?.END_POINTS?.INVITE,
      data
    );
    return response;
  };

  const tenantAcceptInvitation = (invitationId, data, user, tenant) => {
    const response = dynamicRequest(
      `${config?.intivation_management?.END_POINTS?.ACCEPT_TENANT_INVITE}/${invitationId}`,
      data,
      user,
      tenant
    );
    return response;
  };

  const userAcceptInvitation = (invitationId) => {
    const response = POST(
      `${config?.intivation_management?.END_POINTS?.ACCEPT_USER_INVITE}/${invitationId}`,
      null
    );
    return response;
  };

  const declineInvitation = (invitationId) => {
    const response = POST(
      `${config?.intivation_management?.END_POINTS?.REJECT_INVITE}/${invitationId}`,
      null
    );
    return response;
  };

  const readInvitation = (invitationId) => {
    const response = POST(
      `${config?.intivation_management?.END_POINTS?.READ_INVITE}/${invitationId}`,
      null
    );
    return response;
  };

  const resendInvitation = (invitationId) => {
    const response = POST(
      `${config?.intivation_management?.END_POINTS?.RESEND_INVITE}/${invitationId}`,
      null
    );
    return response;
  };

  return {
    getInvitations,
    sendInvitation,
    tenantAcceptInvitation,
    userAcceptInvitation,
    declineInvitation,
    readInvitation,
    resendInvitation
  };
};
